<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-08-20 09:50:28
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-03 11:08:14
 -->
<!--  -->
<template>
<div class="concatResource">
  <el-dialog width="75%" top="5vh" :append-to-body="true" :visible.sync="isShow.show">
    <el-container>
    <el-aside width="21.25rem" class="ResourceManage">
        <el-card shadow="hover" class="box-card" body-style="padding:0px;" style="height:95%;width:95%">
            <div slot="header" class="ResourceManage_head" >
               <i  class="fa fa-sitemap ResourceManage_icon" />
              <span class="ResourceManage_title"> 资源树 </span>
              <el-button style="float:right" @click="reset" size="mini" type="primary"> 重置</el-button>
            </div>
            <!-- 搜索区域 -->
            <div class="ResourceManage_Search">
               <el-row>
                <el-col :offset="1" :span="5">
                  <div class="ResourceManage_Search_text">所属应用</div>
                </el-col>
                <el-col :offset="1" :span="15">
                  <el-select size="mini" @change="appKeyChange" v-model="appKey" style="width:100%" placeholder="请选择所属应用">
                       <el-option v-for="(item,index) in appKeyOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-col >
              </el-row>
              <el-row>
                <el-col :offset="1" :span="5">
                  <div class="ResourceManage_Search_text">关联模式</div>
                </el-col>
                <el-col :offset="1" :span="15">
                  <el-select   v-model="concatPattern"  style="width:100%"  size="mini" placeholder="请选择搜索模式">
                     <el-option label="向上级联模式" :value="1"></el-option>
                     <el-option label="向下级联模式" :value="2"></el-option>
                     <el-option label="上下级联模式" :value="3"></el-option>
                     <el-option label="非级联模式" :value="4"></el-option>
                  </el-select>
                </el-col >
              </el-row>
              <el-row>
                <el-col :offset="1" :span="5">
                  <div class="ResourceManage_Search_text">搜索模式</div>
                </el-col>
                <el-col :offset="1" :span="15">
                  <el-select @change="searchPatternChange"  v-model="searchPattern"  style="width:100%"  size="mini" placeholder="请选择搜索模式">
                     <el-option label="区域搜索" :value="true"></el-option>
                     <el-option label="全局搜索" :value="false"></el-option>
                  </el-select>
                </el-col >
              </el-row>
            </div>
            <div class="tree" v-loading="!searchPattern" element-loading-text="禁用"  element-loading-spinner="fa fa-ban">
              <el-tree  ref="mainTree" node-key="id"  lazy :load="loadMainTreeNode"
                @current-change="currentNodeChange"
                :highlight-current='true'
                :expand-on-click-node="false"
                :render-content="renderContent">
              </el-tree>
            </div>
          </el-card>
    </el-aside>
    <el-main>
      <easyCruds ref="mainTable" :tableInfo="mainTable"
      @mainTableReload="mainTableReload"
      >
      <template slot-scope="row" slot="operation">
        <el-switch @change="changeAuth(row.row)"  v-model="row.row.__auth_status__" ></el-switch>
      </template>
      </easyCruds>
    </el-main>
  </el-container>

  </el-dialog>
  </div>
</template>

<script>
import { RESOURSE_CONFIG } from '@/page/config/base_config'

export default {
  data() {
    return {
      mainTable: {
        header: { title: '资源选择器' },
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowDelete: false,
          allowView: false
        },
        table: {
          search_xl: 8,
          search_lg: 12,
          search_md: 24,
          search_sm: 24,
          loading: false,
          height: 535,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: true,
          columns: [{
            prop: 'obj',
            label: '对象',
            isSearchCondition: true,
            type: 'input',
            align: 'left',
            'maxlength': 500,
            required: true
          }, {
            prop: 'description',
            label: '描述',
            rows: 5,
            span: 24,
            type: 'textarea',
            isSearchCondition: true,
            required: true
          }, {
            prop: 'act',
            label: '访问动作',
            width: 150,
            type: 'input',
            'maxlength': 500,
            required: true
          }, {
            prop: 'accessCondition',
            label: '访问条件',
            width: 150,
            isSearchCondition: true,
            type: 'input'
          }, {
            prop: 'resourceType',
            label: '类型',
            sortable: false,
            width: 100,
            isTag: true,
            isSearchCondition: true,
            type: 'select',
            dicData: [{
              label: '数据',
              value: 'DATA'
            }, {
              label: '接口',
              value: 'API'
            }, {
              label: '界面元素',
              value: 'UI'
            }, {
              label: '其他',
              value: 'OTHER'
            }],
            tagFilter: function(columnData) {
              if (columnData === 'DATA') {
                return { data: '数据' }
              } else if (columnData === 'API') {
                return { data: '接口' }
              } else if (columnData === 'UI') {
                return { data: '界面元素' }
              } else {
                return { data: '其他' }
              }
            },
            required: true
          },
          {
            prop: 'sort',
            label: '排序',
            type: 'number',
            showInTable: false,
            'controlsPosition': '',
            'minRows': 0,
            'maxRows': 100
          }, {
            prop: 'resourceStatus',
            label: '状态',
            width: 100,
            type: 'select',
            isSearchCondition: true,
            isTag: true,
            dicData: [{
              'label': '可用',
              'value': 1
            }, {
              'label': '不可用',
              'value': 2
            }],
            required: true,
            tagFilter: function(columnData) {
              if (columnData === 1) {
                return { data: '可用', type: 'success' }
              } else {
                return { data: '不可用', type: 'warning' }
              }
            }
          }, {
            prop: 'unionSubjectType',
            label: '关联状态',
            isSearchCondition: true,
            showInTable: false,
            dicData: [{ 'label': '已关联', 'value': 'IN' }, { 'label': '未关联', 'value': 'NOT_IN' }],
            type: 'select'
          }],
          operation: {
            width: 150,
            slotName: 'operation'
          },
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          tableData: [],
          reload: 'mainTableReload',
          reloadConditions: { },
          addDefultValue: { }
        }},

      /** 搜索模式控制 */
      searchPattern: true,
      concatPattern: 2,
      /** appKey 控制 */
      appKey: null,
      appKeyOptions: [],
      /** 资源树控制 */
      loadNodeMap: new Map(),
      /** 当前选中的节点 */
      currentTableNode: null
    }
  },

  props: ['isShow', 'optionRow'],

  components: { },

  methods: {
    /** 获取所属应用 */
    getSelectOPtion: function() {
      this.$http.post('/resource/list-authorized-resource', { entity: {
        'obj': 'Permission.App',
        'appKey': '@PUBLIC'
      }},
      { params: { isRecursive: true, recursiveWithCondition: true, recursiveIgnoreProperties: ['obj'], onlyChild: true }}).then(response => {
        let result = []
        response.data.forEach(element => {
          let temp = {}
          element.resourceExtList.forEach(item => {
            if (item.extPropertyKey === 'appName') {
              temp.label = item.extPropertyValue
            } else if (item.extPropertyKey === 'appKey') {
              temp.value = item.extPropertyValue
            }
          })
          result.push(temp)
        })
        this.appKeyOptions = result
        if (result.length !== 0) {
          this.appKey = result[0].value
          this.appKeyChange()
        }
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    reset: function() {
      let data = this.loadNodeMap.get('root')
      if (data) {
        this.reLoadMainTreeNode(data.node, data.resolve)
        this.currentNodeChange(null, data.node)
      }
    },
    searchPatternChange: function() {
      this.mainTable.header.title = '资源控制'
      this.mainTable.table.tableData = []
      this.mainTable.table.paging.total = 0
      if (this.searchPattern) {
        // 局部搜索
        if (this.currentTableNode) {
          this.currentNodeChange(null, this.currentTableNode)
        }
      } else {
        // 全局搜索
        this.mainTableReload(Object.assign(this.$refs.mainTable.getReloadConditions(), { pageNum: 1 }))
      }
    },
    /**
     * 选择的树节点改变时,触发该函数
     */
    currentNodeChange: function(data, node) {
      this.mainTable.header.title = node.data.description
      this.currentTableNode = node
      this.$nextTick(() => {
        this.mainTableReload(Object.assign(this.$refs.mainTable.getReloadConditions(), { pageNum: 1 }))
      })
    },
    /** 当主表需要重载的时候 */
    mainTableReload: function(params) {
      if (!this.appKey) return this.$message.warning('appKey 丢失,请刷新页面后再尝试')
      if (!this.currentTableNode && this.searchPattern) return this.$message.warning('当前选中节点 丢失,请刷新页面后再尝试')
      this.mainTable.table.loading = true
      this.$http.post('/resource/query', {
        'entity': {
          'obj': params.obj,
          'resourceType': params.resourceType,
          'accessCondition': params.accessCondition,
          'description': params.description,
          'resourceStatus': params.resourceStatus,
          'appKey': this.appKey,
          'pid': !this.searchPattern ? null : this.currentTableNode.data.id === 'root' ? '' : this.currentTableNode.data.id
        },
        'orderItemList': [{
          'asc': true,
          'column': 'sort' }]
      }, {
        params: {
          'pageNum': params.pageNum || 1,
          'pageSize': params.pageSize || 15,
          'unionSubjectType': params.unionSubjectType,
          subjectIdList: this.optionRow.id
        }
      }).then(response => {
        this.mainTable.table.loading = false
        response.data.records.forEach(item => {
          let policySubjectList = item.policySubjectList
          if (policySubjectList && policySubjectList.length >= 1) {
            item.__auth_status__ = true
          } else {
            item.__auth_status__ = false
          }
        })
        this.mainTable.table.tableData = response.data.records
        this.mainTable.table.paging.total = response.data.total || response.data.records.length
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    },
    /**
     * 树节点展示 render 函数
     */
    renderContent(h, { data }) {
      return (
        <span style='display: flex; flex: 1; align-items: center; justify-content: space-between; font-size: 0.625rem; padding-right: 0.5rem;'>
          {data.description}
        </span>
      )
    },
    appKeyChange: function() {
      let data = this.loadNodeMap.get('root')
      if (data) {
        this.reLoadMainTreeNode(data.node, data.resolve)
        this.currentNodeChange(null, data.node)
      }
    },
    reLoadMainTreeNode: function(node, resolve) {
      node.childNodes = []
      this.loadMainTreeNode(node, resolve)
    },
    loadMainTreeNode: function(node, resolve) {
      if (!node.data) {
        node.data = { id: 'root', description: '资源控制' }
      }
      this.loadNodeMap.set(node.data.id, { node, resolve })
      if (!this.appKey) return
      this.$http.post('/resource/list', { 'entity': {
        'appKey': this.appKey,
        'pid': node.data.id === 'root' ? (RESOURSE_CONFIG.RESOURSE_ROOT_ID === undefined ? '' : RESOURSE_CONFIG.RESOURSE_ROOT_ID) : node.data.id
      }, 'orderItemList': [{
        'asc': true,
        'column': 'sort' }] }).then(response => {
        node.childNodes = []
        return resolve(response.data)
      }).catch(error => {
        node.childNodes = []
        resolve([])
        this.$message.error(error.msg)
      })
    },

    /** When  change permissions */
    changeAuth: function(row) {
      this.mainTable.table.loading = true
      let postUrl = row.__auth_status__ ? '/permission/subject/subject/policy' : '/permission/subject/subject/policy/del'
      let params = {
        'appKey': this.appKey,
        'resourceId': row.id,
        subjectId: this.optionRow.id
      }
      let cancatP = this.getcancatPattern()
      if (cancatP) {
        params['recursiveTypeEnum'] = cancatP
      }
      this.$http.post(postUrl, null, { params }).then(response => {
        this.mainTable.table.loading = false
        this.$message.success('操作成功。')
        if (!this.searchPattern) {
          this.$refs.mainTable.reload()
        }
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg)
        row.__auth_status__ = !row.__auth_status__
      })
    },
    /** 初始化表格 */
    Initialize: function(params) {
      this.concatPattern = 2
      if (this.appKeyOptions.length === 0) {
        this.getSelectOPtion()
      } else {
        this.$nextTick(() => this.reset())
      }
    },
    getcancatPattern: function() {
      switch (this.concatPattern) {
        case 1: return 'up'
        case 2: return 'down'
        case 3: return 'all'
        case 4: return null
      }
    }

  }
}
</script>
<style lang='scss' scoped>
.easyCrud {
    &_head {
        &_icon {
            color: #409EFF
        }
        &_title {
            text-indent: 2px;
            color: #409EFF;
        }
        &_right{
          border: solid red 0px;
          width: 10rem;
          float: right;
        }
    }
}
.ResourceManage {
    &_head {
        &_icon {
            color: #409EFF
        }
        &_title {
            text-indent: 2px;
            color: #409EFF;
        }
        text-indent:2px;
        color:#409EFF;
    }
    &_Search{
      margin-top: 0.625rem;
      &_text{
        color: #409EFF;
        font-size: 0.9375rem;
        line-height: 1.75rem;
        text-align: center;
      }
    }
}
.aside-menu{
  margin: 0.625rem;
  display: flex;
  flex-direction:row;
  flex-wrap: nowrap;
  flex-direction: row;
  &-buttonBox{
    flex-grow: 1;
    text-align: center
  }
}
.tree {
    overflow-y:scroll;
    overflow-x: scroll;
    height: 40.625rem;
    }
</style>

